const $ = jQuery;
class WhatWeDo {
    constructor() {
        this.slider = $('.c-slider.cc-what_we_do');
        this.prevButton = $('.e-slider_btn.cc-prev.cc-what_we_do');
        this.nextButton = $('.e-slider_btn.cc-next.cc-what_we_do');
        this.init();
    }

    init() {
        // Initialize slick slider
        this.slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: true,
            speed: 600,
            fade: true,
            prevArrow: this.prevButton,
            nextArrow: this.nextButton,
            // responsive: [
            //     {
            //         breakpoint: 992,
            //         settings: {
            //             slidesToShow: 1.2
            //         }
            //     },
            //     {
            //         breakpoint: 576,
            //         settings: {
            //             slidesToShow: 1.1
            //         }
            //     }
            // ]
        });
    }
}

export default WhatWeDo;
